import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogEntity, DialogNotes } from '@lyearn/molecules';
import * as User from '@/components/User';

import useMasquerade from '../../hooks/useMasquerade';
import { MasqueradeConfirmationModalProps } from './types';
import { getMasqueradeDetailItems } from './utils';

const MasqueradeConfirmationModal: React.FC<MasqueradeConfirmationModalProps> = (props) => {
  const { learner, onClose } = props;

  const { t } = useTranslation();

  const { onMasqueradeStart } = useMasquerade({
    masqueradeAsId: learner.id,
    action: 'START_MASQUERADE',
  });

  const masqueradeDetailItems = useMemo(() => getMasqueradeDetailItems(t), [t]);

  return (
    <AlertDialog
      header={{
        title: t('Admin:Masquerade.MasqueradeAsLearner'),
        description: t('Admin:Masquerade.MasqueradeAsLearnerDescription'),
      }}
      primaryAction={{
        label: t('Common:Actions.Masquerade'),
        onClick: onMasqueradeStart,
      }}
      onClose={onClose}>
      <User.Provider className="w-full flex-col" user={learner}>
        <DialogEntity
          description={learner.uniqueId}
          image={<User.ProfilePicture size={48} />}
          titleNode={<User.Name className="ellipsis" variant="body-short-01" />}
        />
        <DialogNotes items={masqueradeDetailItems} />
      </User.Provider>
    </AlertDialog>
  );
};

export default MasqueradeConfirmationModal;
